import { createProvider } from '@frontend/store';
import { DEFAULT_FILTER_VALUES } from '../constants';
import { SelectedFilters } from '../types';

interface ContactTaskListStore {
  selectedFilters: SelectedFilters;
  setFilters: (filters: SelectedFilters) => void;
}

const { Provider: ContactTaskListStoreProvider, useStore: useContactTaskListStoreUnsafe } =
  createProvider<ContactTaskListStore>()((set, _get) => ({
    selectedFilters: DEFAULT_FILTER_VALUES,
    setFilters: (filters: SelectedFilters) => {
      set({ selectedFilters: filters });
    },
  }));

// Safe version that returns undefined when provider is not wrapped
export const useContactTaskListStore = <T extends (state: ContactTaskListStore) => any>(
  selector: T
): ReturnType<T> | undefined => {
  try {
    return useContactTaskListStoreUnsafe(selector);
  } catch (error) {
    // If no provider is wrapped, return undefined
    return undefined;
  }
};

export { ContactTaskListStoreProvider };
